import React from "react";
import { MapPinned, Landmark, Layers, Users, MessagesSquare, Sparkles } from "lucide-react";
import { SectionHeading } from "./ui";

const POINTS = [
  { icon: MapPinned, title: "Southern California Focus", desc: "Local real estate expertise across the region we serve." },
  { icon: Landmark, title: "Real Estate & Mortgage Support", desc: "Two sides of your move, handled in one place." },
  { icon: Layers, title: "Buyer, Seller & Agent Services", desc: "One brokerage supporting every side of the transaction." },
  { icon: Users, title: "Broker-Led Guidance", desc: "Direct support and leadership you can count on." },
  { icon: Sparkles, title: "Modern Tools & Systems", desc: "Technology built to make the process simpler." },
  { icon: MessagesSquare, title: "Clear Communication", desc: "Straightforward answers at every step of the way." },
];

export const WhySection = () => (
  <section className="py-16 lg:py-24 bg-white">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <SectionHeading
        eyebrow="Why Us"
        title="A Modern Brokerage With Local Roots"
        center
      />
      <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {POINTS.map((p) => (
          <div
            key={p.title}
            data-testid={`why-card-${p.title.toLowerCase().replace(/[^a-z]+/g, "-")}`}
            className="lift flex gap-4 p-6 rounded-[20px] border border-[#E5E5E5] hover:border-[#C9A961]"
          >
            <div className="shrink-0 w-11 h-11 rounded-xl bg-[#F5F5F5] flex items-center justify-center">
              <p.icon className="text-[#254369]" size={20} />
            </div>
            <div>
              <h3 className="font-heading font-bold text-[16px] text-[#2D2D37]">{p.title}</h3>
              <p className="mt-1 text-sm leading-relaxed text-[#2D2D37]/65">{p.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);
